import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the organization to confirm. */
const organizationToDeleteSignal = createSignal<number | null>(null);

export const setOrganizationToDelete = (organizationId: number | null): void => {
	organizationToDeleteSignal.value = organizationId;
};

export default organizationToDeleteSignal;
